import Field from './Field';

export default class Group extends Field {

    constructor() {
        super();
        this.type = 'Group';
        this.maxSize = [32, 52];
        this.minSize = [2, 2];
    }
    
    create(target, options) {
        let container = document.createElement('div');
        container.classList.add('sheet-group');
        
        this.elements = {container};
        this.update(options);

        target.append(container);
    }

    update(options) {
        this.elements.container.style.fontSize = `${options.unit}px`;
        this.elements.container.style.backgroundColor = options.highlight ? '#444' : 'transparent';
        this.elements.container.style.gridRowStart = 1 + this.y;
        this.elements.container.style.gridColumnStart = 1 + this.x;
        this.elements.container.style.gridRowEnd = (1 + this.y) + (this.height);
        this.elements.container.style.gridColumnEnd = (1 + this.x) + (this.width);

        this.elements.container.classList[options.selectedId === this.id ? 'add' : 'remove']('selected');
    }

    set() {}

    get() {return '';}

    clean() {}

    error() {}

    fix() {}

}